import React from 'react';

const SettingsPage = ({ profileData }) => {
  const settingsCategories = [
    {
      title: 'Security',
      description: 'Manage your wallet security and backup options',
      icon: '🔒'
    },
    {
      title: 'Networks',
      description: 'Configure blockchain networks and connections',
      icon: '🌐'
    },
    {
      title: 'Notifications',
      description: 'Control your notification preferences',
      icon: '🔔'
    },
    {
      title: 'Appearance',
      description: 'Customize your wallet interface',
      icon: '🎨'
    }
  ];

  return (
    <div>
      <h1 style={{ fontSize: '32px', fontWeight: '700', marginBottom: '12px' }}>
        Settings
      </h1>
      <p style={{ fontSize: '16px', color: '#666', marginBottom: '40px' }}>
        Manage your wallet preferences and security settings.
      </p>

      <div style={{ marginBottom: '40px' }}>
        <h2 style={{ fontSize: '24px', fontWeight: '600', marginBottom: '20px' }}>
          Settings Categories
        </h2>
        <div className="earn-categories">
          {settingsCategories.map((category, index) => (
            <div key={index} className="category-card">
              <div style={{ fontSize: '24px', marginBottom: '12px' }}>
                {category.icon}
              </div>
              <div className="category-title">{category.title}</div>
              <div className="category-description">{category.description}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="tokens-section">
        <div className="section-header">
          <h2 className="section-title">Wallet Information</h2>
        </div>

        <div style={{ padding: '20px 0' }}>
          <div style={{ marginBottom: '16px' }}>
            <div style={{ fontSize: '14px', color: '#666', marginBottom: '4px' }}>Version</div>
            <div style={{ fontSize: '16px', fontWeight: '500' }}>OISY Prototype v1.0.0</div>
          </div>
          <div style={{ marginBottom: '16px' }}>
            <div style={{ fontSize: '14px', color: '#666', marginBottom: '4px' }}>Network</div>
            <div style={{ fontSize: '16px', fontWeight: '500' }}>Internet Computer</div>
          </div>
          <div>
            <div style={{ fontSize: '14px', color: '#666', marginBottom: '4px' }}>Current Profile</div>
            <div style={{ fontSize: '16px', fontWeight: '500' }}>{profileData.name}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettingsPage;
